import React from "react";

const OffersListView = React.lazy(() => import("./OffersList.view"));

const OffersListLoadable = () => <OffersListView />;
export default () => <OffersListLoadable />;
